export enum RoleSensitivityLevel {
  NA = 0,
  HighRisk = 1,
  Severe = 2,
  Moderate = 3,
  Limited = 4,
}
